export class PasswdChangeModel {
    public currentPassword: string;
    public newPassword: string;
    public newPasswordRepeat: string;

    public constructor(data?: PasswdChangeModel) {
        this.currentPassword = (data && data.currentPassword) ? data.currentPassword : '';
        this.newPassword = (data && data.newPassword) ? data.newPassword : '';
        this.newPasswordRepeat = (data && data.newPasswordRepeat) ? data.newPasswordRepeat : '';
    }
}
